import { LocalizationClient } from '@mae/client-web/clients';
import { ITypedBrowserLocalization, ILocalization } from './localization';

const MAE_LOCALIZATION_KEY = 'mae_localization_';

/**
 *
 * @returns User or Browser language
 */
export function getLanguage(): string {
	const browserLanguage = navigator.language;
	const storage = localStorage.getItem(LocalizationClient.storageId);
	if (!storage) {
		return browserLanguage;
	}

	return JSON.parse(storage)?.userLanguage || browserLanguage;
}

export async function fetchLocalization(language: string, timestamp: number): Promise<ITypedBrowserLocalization> {
	return LocalizationClient.getBrowserLocalization(language, timestamp) as Promise<ITypedBrowserLocalization>;
}

export async function loadLocalization(language?: string): Promise<ILocalization> {
	const _language = language || getLanguage();
	const cachedLocalization = readFromStorage(_language);

	const localizationPromise = fetchLocalization(_language, cachedLocalization?.timestamp ?? 0);

	return localizationPromise.then((serverLocalization: ITypedBrowserLocalization | void | Response) => {
		//no localization available for
		if (!serverLocalization) {
			throw new Error(`No localization available for language:"${_language}".`);
		}

		//nothing changed, user cached locales
		if (serverLocalization instanceof Response && serverLocalization.status == 204) {
			if (!cachedLocalization?.localization) {
				throw new Error(`Unexpected server response for language:"${_language}" timestamp:${cachedLocalization?.timestamp}`);
			}

			return cachedLocalization.localization;
		}

		saveToStorage(_language, serverLocalization as ITypedBrowserLocalization);

		return (serverLocalization as ITypedBrowserLocalization).localization;
	});
}

//#region private
function getLanguageStorageKey(language: string) {
	return `${MAE_LOCALIZATION_KEY}${language}`;
}

function readFromStorage(language: string): ITypedBrowserLocalization | undefined {
	const languageStorageKey = getLanguageStorageKey(language);

	const fetchedLocalization = localStorage.getItem(languageStorageKey);

	return fetchedLocalization ? JSON.parse(fetchedLocalization) : undefined;
}

function saveToStorage(language: string, localization: ITypedBrowserLocalization) {
	const languageStorageKey = getLanguageStorageKey(language);

	localStorage.setItem(languageStorageKey, JSON.stringify(localization));
}
//#endregion
